import MailToLink from '@vromo/ui/components/MailToLink';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './helpSection.style';

const HelpSection = () => {
    const { t } = useTranslation();
    const needHelpSubStrings = t('findFleets.needHelp').split(t('findFleets.externalTools'));
    const supportEmail = 'support@vromo.io';
    const contactSupportText = t('findFleets.contactSupport').replace(supportEmail, '');

    return (
        <p style={styles.helpText}>
            {needHelpSubStrings[0]}
            <a
                style={styles.linkText}
                href="https://www.unitedstateszipcodes.org/zip-code-radius-map.php"
                target="_blank"
                rel="noreferrer noopener">
                {t('findFleets.externalTools')}
            </a>
            {needHelpSubStrings[1]}
            <p>
                {contactSupportText}
                <MailToLink address={supportEmail} />
            </p>
        </p>
    );
};

export default memo(HelpSection);
